import Card, { CardProps } from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";

import { CommunicationTarget } from "../../../graphql/models";

import useCommunicationTargetCardStyles from "./communication_target_card.style";

export interface CommunicationTargetCardProps extends CardProps {
  target: CommunicationTarget;
}

export function CommunicationTargetCard(props: CommunicationTargetCardProps) {
  const { target, ...cardProps } = props;
  const classes = useCommunicationTargetCardStyles();

  return (
    <Card className={classes.card} variant={cardProps.variant ?? "outlined"}>
      <CardContent>
        <Typography variant="h5" color="textSecondary" gutterBottom>
          {target.name}
        </Typography>
        <List component="nav">
          <ListItem>
            <ListItemIcon>
              <MeetingRoomIcon />
            </ListItemIcon>
            <ListItemText primary={target.apartmentCode ?? "-"} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <AlternateEmailIcon />
            </ListItemIcon>
            <ListItemText primary={target.email} />
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
}
